import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { g as getPadding } from '../LocalModules/storm-ui-utils/dist/esm/getPadding-Bvzhcf_u-BhHYy5ob.js';
import { D as DEVICE_TYPES } from '../LocalModules/storm-ui-utils/dist/esm/deviceTypes-wW4MAd2m-wW4MAd2m.js';

const CardStyled = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30065889__sc-1ofhy6d-0"
})(["display:flex;flex-direction:column;flex-wrap:nowrap;justify-content:flex-start;align-content:stretch;align-items:stretch;border:", ";background:", ";box-shadow:", ";border-radius:", ";> *:first-child{border-top-left-radius:", ";border-top-right-radius:", ";}> *:last-child{border-bottom-left-radius:", ";border-bottom-right-radius:", ";}width:100%;ul,ol{color:inherit;}"], ({
  theme
}) => theme.card.border, ({
  theme
}) => theme.card.bg, ({
  theme
}) => theme.card.boxShadow, ({
  theme
}) => theme.card.radius, ({
  theme
}) => theme.card.radius, ({
  theme
}) => theme.card.radius, ({
  theme
}) => theme.card.radius, ({
  theme
}) => theme.card.radius);
CardStyled.displayName = 'CardStyled';
const CardBodyStyled = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30065889__sc-1ofhy6d-1"
})(["", " padding:", "px;flex:1 1 auto;", ""], ({
  visible
}) => visible === false ? 'display:  none;' : '', ({
  theme,
  padding
}) => getPadding(theme, padding), isMobile(css(["padding:", "px;"], ({
  theme,
  padding
}) => getPadding(theme, padding, DEVICE_TYPES.MOBILE))));
CardBodyStyled.displayName = 'CardBodyStyled';

export { CardBodyStyled as C, CardStyled as a };
//# sourceMappingURL=Card.styles-BX0II1Bm.js.map
